/**
 * 最终订货接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const api = {
  //备注/动作 集合
    memos:{
        print:"打印",
        excel:"输出EXCEL",
        view:"查看",
        update:"修改",
        del:"删除",
        add:"新增",
    },
  /**
   * 向系统录入log日志
   * @param _menuId 菜单id 从路由获取
   * @param _memo 备注/动作
   * @returns {*}
   */
    record(_menuId,_memo) {
      return axios.put(`${Vue.prototype.$base.API_PATH}/sys/log`, {
        menuId:_menuId,
        memo:_memo
      });
    },
  /**
   * 得到当前系统日期时间 yyyy/mmm/dd 01:01:01
   */
  nowTime() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/sys/time`);
  }
}

export default api;



// WEBPACK FOOTER //
// ./src/api/syslog.js